import { staticURL } from 'core/url';

function cloudinaryURL(imgServe, image, size) {
  const base = `res.cloudinary.com/${imgServe.key}/image/upload`;
  // c_fill: crop fill
  // g_auto: gravity auto (smart detection of what to crop)
  // q_auto: quality: auto file format, compression rate and encoding
  return `https://${base}/w_${size[0]},h_${size[1]},c_fill,g_auto,q_auto/${imgServe.folder}/${image.path}`;
}

function ossImageURL(imgServe, image, size) {
  const base = `${imgServe.folder}.oss-accelerate.aliyuncs.com`;
  return `https://${base}/${image.path}?x-oss-process=image/resize,w_${size[0]},h_${size[1]}`;
}

/* Convert URL of original image to URL of CDN/filestack for resizing.
 If element does not have an image might give a fallback URL

 @param size: must be an 2-element array (width, hight)
 */
export function imageSrc(image, fallback = '', size = null) {
  if (image && image.src) {
    if (image.private) {
      return image.url;
    }
    // if images contains a size information and not
    // being served from local file system,
    // retrieve it from filestack/CDN
    const imgServe = JSON.parse(IMG_SERVE);
    if (image.completed !== false && imgServe.provider && size) {
      // imgServe contains:
      //   - provider (String) name of service
      //   - key (String) used on URL path identify us on service
      //   - folder (String) identify the running instance
      if (imgServe.provider === 'cloudinary') {
        return cloudinaryURL(imgServe, image, size);
      }
      if (imgServe.provider === 'oss') {
        return ossImageURL(imgServe, image, size);
      }
      throw new Error(`Error unknown image provider: ${imgServe.provider}`);
    } else {
      return image.src;
    }
  }
  if (!fallback) {
    return '';
  }
  return staticURL(fallback);
}
